import type {
  CostPaymentRecordKind,
  CostPaymentRecordParam,
} from "../../types";

export type PaymentKindFilter = CostPaymentRecordKind | "all";
export type PaymentStatusFilter = "all" | "needs-attention" | "paid";

export function getPaymentRecordKind(
  record: CostPaymentRecordParam,
): CostPaymentRecordKind {
  if (record.kind) return record.kind;
  const searchable =
    `${record.label} ${record.source} ${record.phase}`.toLowerCase();
  if (searchable.includes("claim") || searchable.includes("insurance")) {
    return "claim";
  }
  if (searchable.includes("receipt") || searchable.includes("pharmacy")) {
    return "receipt";
  }
  if (searchable.includes("balance") || record.status === "due") {
    return "balance";
  }
  return "payment";
}

const NEEDS_ATTENTION_STATUSES = new Set([
  "submitted",
  "waiting-eob",
  "needs-receipt",
  "partially-covered",
  "ready-reimbursement",
  "denied",
  "due",
  "review",
]);

export function filterPaymentRecords(
  records: CostPaymentRecordParam[],
  options: {
    query: string;
    kind: PaymentKindFilter;
    status: PaymentStatusFilter;
  },
): CostPaymentRecordParam[] {
  const normalizedQuery = options.query.trim().toLowerCase();

  return records.filter((record) => {
    const matchesKind =
      options.kind === "all" || getPaymentRecordKind(record) === options.kind;
    const matchesStatus =
      options.status === "all" ||
      (options.status === "paid"
        ? record.status === "paid"
        : NEEDS_ATTENTION_STATUSES.has(record.status));
    const matchesQuery =
      !normalizedQuery ||
      `${record.label} ${record.provider} ${record.source} ${record.date}`
        .toLowerCase()
        .includes(normalizedQuery);

    return matchesKind && matchesStatus && matchesQuery;
  });
}
